import React from "react";

import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import WhatYouGet from "@/components/landing/WhatYouGet";
import HowItWorks from "@/components/landing/HowItWorks";
import Services from "@/components/landing/Services";
import Portfolio from "@/components/landing/Portfolio";
import Testimonials from "@/components/landing/Testimonials";
import Stats from "@/components/landing/Stats";
import Pricing from "@/components/landing/Pricing";
import WhyUs from "@/components/landing/WhyUs";
import LeadForm from "@/components/landing/LeadForm";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import MobileStickyCTA from "@/components/landing/MobileStickyCTA";

export default function Landing() {
  return (
    <main
      className="min-h-screen bg-[var(--gf-bg)] text-[var(--gf-primary)] font-body"
      data-testid="landing-page"
    >
      <Header />

      <Hero />

      <TrustBar />

      <Problem />

      <Solution />

      <WhatYouGet />

      <HowItWorks />

      <Services />

      <Portfolio />

      <Testimonials />

      <Stats />

      <Pricing />

      <WhyUs />

      <LeadForm />

      <FinalCTA />

      <Footer />

      <FloatingWhatsApp />

      <MobileStickyCTA />
    </main>
  );
}
